import ProxyBase from '../../ProxyBase';
import ServiceProxyConfig from '../../../../configs/ServiceProxyConfig';

class TopDownloadProxy extends ProxyBase {
  downloadTopBreakout(params) {
    return this.get('DownloadTopBreakout', params, null, 'download');
  }

  downloadTopGainer(params) {
    return this.get('DownloadTopGainer', params, null, 'download');
  }

  downloadTopForeignTrading(params) {
    return this.get('DownloadTopForeignTrading', params, null, 'download');
  }

  downloadTopLoser(params) {
    return this.get('DownloadTopLoser', params, null, 'download');
  }

  downloadTopNewLow(params) {
    return this.get('DownloadTopNewLow', params, null, 'download');
  }

  downloadTopNewHigh(params) {
    return this.get('DownloadTopNewHigh', params, null, 'download');
  }

  downloadTopVolume(params) {
    return this.get('DownloadTopVolume', params, null, 'download');
  }

  downloadTopValue(params) {
    return this.get('DownloadTopValue', params, null, 'download');
  }
}

const topDownloadProxy = new TopDownloadProxy(
  ServiceProxyConfig.TopMover.ServiceDownload,
);
export default topDownloadProxy;
